
import { Options, Vue } from 'vue-class-component'

@Options({
    emits: ['close', 'submit'],
    data() {
        return {
            name: '',
            phone: '',
            address: '',
        }
    },
    methods: {
        closeClick() {
            this.$emit('close')
        },
        submitClick() {
            if (!this.name) return this.$toast('请输入姓名')
            if (!this.phone) return this.$toast('请输入联系方式')
            if (!this.address) return this.$toast('请输入收货地址')
            this.$emit('submit', {
                name: this.name,
                phone: this.phone,
                address: this.address,
            })
        }
    }
})
export default class InfoModal extends Vue { }
